/**
 * Normalizes experience ticket unit labels so formatting is stable regardless of
 * API casing (e.g. "/Participant" vs "/participant").
 */
export function normalizeExperienceTicketUnitLabel(ticketUnitLabel: string): string {
  if (!ticketUnitLabel) {
    return ticketUnitLabel
  }

  const hasLeadingSlash = ticketUnitLabel.startsWith('/')
  const hasTrailingAsterisk = ticketUnitLabel.endsWith('*')
  const unit = ticketUnitLabel.replace(/^\//, '').replace(/\*$/, '').toLowerCase()

  return `${hasLeadingSlash ? '/' : ''}${unit}${hasTrailingAsterisk ? '*' : ''}`
}

/**
 * Resolves the sale unit shown on experience search tiles (cash and points).
 * Matches PriceRowPrice: per-ticket label for "from" pricing, otherwise "total".
 */
export function getExperienceTileSaleUnit(options: {
  isFromPrice: boolean
  ticketUnitLabel: string
  totalLabel: string
}): string {
  const { isFromPrice, ticketUnitLabel, totalLabel } = options
  const raw = isFromPrice ? ticketUnitLabel : totalLabel
  return normalizeExperienceTicketUnitLabel(raw)
}
